/* Copyright (c) 2018 Scaper */

import { parse, stringify } from "query-string";
import { RouteComponentProps } from "react-router";

export interface IAppRouteParams {
    placeId?: string;
}

export const APP_PATH = "/app";

export const AppPath = {
    of: (params: IAppRouteParams) => {
        const stringifiedParams = stringify(params);
        const queryString = stringifiedParams === "" ? "" : `?${stringifiedParams}`;
        return `${APP_PATH}${queryString}`;
    },
    parse: (props: RouteComponentProps<IAppRouteParams>) => {
        const queryParams = parse(props.location.search);
        return { ...queryParams };
    },
};
